import React from 'react';
import styled from 'styled-components';
import { ITagSelectOption } from './types';

interface TagSelectOptionProps {
  data: ITagSelectOption;
  innerProps: Record<string, any>;
  innerRef: React.Ref<HTMLDivElement>;
}

const TagSelectOption: React.FunctionComponent<TagSelectOptionProps> = ({
  innerRef,
  data,
  innerProps,
}) => {
  return (
    <TagSelectOptionSC ref={innerRef} {...innerProps} className={'option'}>
      <div className={'root'}>
        <span className={'dot'} style={{ backgroundColor: data.color }} />
        <span className={'label'}>{data.label}</span>
      </div>
    </TagSelectOptionSC>
  );
};

const TagSelectOptionSC = styled.div`
  padding-left: 12px;
  padding-right: 12px;

  .root {
    display: flex;
    align-items: center;
    width: 100%;
    cursor: pointer;
    padding: 8px;
    font-size: 14px;
    line-height: 30px;

    .dot {
      width: 15px;
      height: 15px;
      border-radius: 50%;
      display: inline-block;
      margin-right: 10px;
      margin-left: 10px;
    }

    &:hover {
      background: rgba(235, 236, 240, 0.5);
      border-radius: 8px;
    }
  }
`;

export default React.memo(TagSelectOption);
